import { render, staticRenderFns } from "./settings-all.vue?vue&type=template&id=6528a6e6&"
import script from "./settings-all.vue?vue&type=script&lang=ts&"
export * from "./settings-all.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports